module.exports = function() {
  return new Worker(__webpack_public_path__ + "efab62fda4e18e9d6b22.worker.js");
};